import React, { useContext } from 'react';
import { SchibstedPrivacySettingsContext } from '../schibsted-privacy-settings-context.js';
import FinnLogo from './finn-logo.js';
import { ToriLogo } from './tori-logo.js';
import { DBALogo } from './dba-logo.js';

export default function Logo(
    props: React.SVGProps<SVGSVGElement>,
): React.JSX.Element {
    const { brand } = useContext(SchibstedPrivacySettingsContext);
    switch (brand.toUpperCase()) {
        case 'FINN':
            return FinnLogo(props);
        case 'TORI':
            return ToriLogo(props);
        case 'DBA':
            return DBALogo(props);
    }
    return ToriLogo(props); // Default to Tori. Should maybe be an empty logo?
}
